import axios from "axios";
import * as Cookies from 'js-cookie'

import store from "@/store";
import router from "@/router";

axios.interceptors.request.use((request) => {
  // document.body.classList.add('loading-indicator');
  let userInfo =  JSON.parse(localStorage.getItem('user'))
  let timezone = null;
  timezone = userInfo && userInfo.timezone ? userInfo.timezone : (Intl.DateTimeFormat().resolvedOptions().timeZone).replace('Asia/Calcutta', 'Asia/Kolkata')
  const token = Cookies.get("token");
  if (token) {
    request.headers.common["Authorization"] = `Bearer ${token}`;
  }
  request.headers.common["timezone"] = `${timezone}`;
  return request;
});

axios.interceptors.response.use(
  (response) => {
    // store.commit("setIsLoading", false);
    return response;
  },
  (error) => {
    const status = error.response && error.response.data.statusCode;
    if (status === 200) {
      // Vue.notify({
      //   group: "foo",
      //   type: "success",
      //   title: "SUCCESS",
      //   text: "Your request processed successfully.",
      // });
    }

    if (status === 313) {
      const message = {
        title: "SESSION_CREATE_UPDATE_ERROR",
        text: "Some error occured during session creation/updation.",
      }
      store.commit("setError", message);
    }

    if (status === 315) {
      const message = {
        title: "COURSE_CREATE_UPDATE_ERROR",
        text: "Some error occured during course creation/updation.",
      }
      store.commit("setError", message);
    }

    if (status === 317) {
      const message = {
        title: "PRIVATE_SESSION_CREATE_UPDATE_ERROR",
        text: "Not Authorized for this request.",
      }
      store.commit("setError", message);
    }

    if (status === 319) {
      const message = {
        title: "ENTITY_NOT_VALID",
        text: "Requested entity not valid or does not exists in the system.",
      }
      store.commit("setError", message);
      router.push({ name: 'DashboardBeforeLogin' })
    }

    if (status === 321) {
      const message = {
        title: "START_DATE_NOT_VALID",
        text:
          "Start date time should be 2 hours greater than current date time.",
      }
      store.commit("setError", message);
    }

    if (status === 323) {
      const message = {
        title: "END_DATE_NOT_VALID",
        text: "End date time should be greater than start date time.",
      }
      store.commit("setError", message);
    }
    if (status === 325) {
      const message = {
        title: "SESSION_SLOT_OCCUPIED",
        text: "Session slot timing already occupied.",
      }
      store.commit("setError", message);
    }

    if (status === 327) {
      const message = {
        title: "DATE_NOT_FOUND",
        text: "Dates are not available.",
      }
      store.commit("setError", message);
    }

    if (status === 329) {
      const message = {
        title: "INVALID_CREDENTIAL",
        text: "Invalid User name or password.",
      }
      store.commit("setError", message);
    }

    // if (status === 331) {
    //   const message = {
    //     title: "EMAIL_ALREADY_TAKEN",
    //     text: "User with this email is already registered.",
    //   }
    //   store.commit("setError", message);
    // }

    if (status === 333) {
      const message = {
        title: "SLOTS_NOT_AVAILABLE",
        text: "Slots doesn't lies between given start date and end date.",
      }
      store.commit("setError", message);
    }

    if (status === 335) {
      const message = {
        title: "COURSE_SESSIONS_NOT_FOUND",
        text: "no sessions found for this course.",
      }
      store.commit("setError", message);
    }

    if (status === 337) {
      const message = {
        title: "INVALID_USER",
        text: "User is not active or not valid or does not exists.",
      }
      store.commit("setError", message);
    }

    if (status === 339) {
      const message = {
        title: "IMAGE_UPLOAD_ERROR",
        text: "There is an error occured while uploading images.",
      }
      store.commit("setError", message);
    }

    if (status === 392) {
      const message = {
        title: "ROOM_SIZE_FULL",
        text: "Room Size is full. No Room available for this slot.",
      }
      store.commit("setError", message);
    }

    if (status === 341) {
      const message = {
        title: "USER_ALREADY_JOINED_ENTITY",
        text: "User Already joined for this session/course.",
      }
      store.commit("setError", message);
    }

    if (status === 417) {
      const message = {
        title: "SOMETHING_BAD_HAPPEN",
        text: "Error occured due to 417",
      }
      store.commit("setError", message);
    }

    if (status === 343) {
      const message = {
        title: error.response && error.response.data.messageCode,
        text: error.response && error.response.data.message,
      }
      store.commit("setError", message);
    }

    if (status === 345) {
      const message = {
        title: "USER_JOINING_ERROR",
        text: "Some error occured during joining process.",
      }
      store.commit("setError", message);
    }

    if (status === 347) {
      const message = {
        title: "SESSION_BATCH_NOT_MAPPED",
        text: "Session is not scheduled yet or already completed.",
      }
      store.commit("setError", message);
    }

    if (status === 349) {
      const message = {
        title: "COURSE_SESSION_BATCH_NOT_MAPPED",
        text: "courses sessions is not scheduled yet or already completed.",
      }
      store.commit("setError", message);
    }

    if (status === 350) {
      const message = {
        title: error.response && error.response.data.messageCode,
        text: error.response && error.response.data.message,
      }
      store.commit("setError", message);
    }

    if (status === 351) {
      const message = {
        title: "TERMS_AND_CONDITION_CONSENT_ERROR",
        text: "You have not accepted terms and conditions.",
      }
      store.commit("setError", message);
    }

    if (status === 353) {
      const message = {
        title: "TRAINER_REVIEW_ERROR",
        text: "error occured while posting review for the trainer.",
      }
      store.commit("setError", message);
    }

    if (status === 355) {
      const message = {
        title: "SESSION_RATING_REVIEW_ALREADY_GIVEN",
        text: "You have already given rating and review to this session.",
      }
      store.commit("setError", message);
    }

    if (status === 357) {
      const message = {
        title: "TRAINER_RATING_REVIEW_ALREADY_GIVEN",
        text: "You have already given rating and review to this trainer.",
      }
      store.commit("setError", message);
    }

    if (status === 359) {
      const message = {
        title: "REVIEW_LIKE_DISLIKE_ERROR",
        text: "Some error occured while liking/disliking the review.",
      }
      store.commit("setError", message);
    }

    if (status === 361) {
      const message = {
        title: "ENTITY_DELETE_ERROR",
        text: "Some error occured while deleting the requested entity.",
      }
      store.commit("setError", message);
    }

    if (status === 363) {
      const message = {
        title: "FOLLOW_TRAINER_ERROR",
        text: "Some error occured while following the trainer.",
      }
      store.commit("setError", message);
    }

    if (status === 365) {
      const message = {
        title: "STORE_CREATE_UPDATE_ERROR",
        text: "Some error occured during store creation/updation.",
      }
      store.commit("setError", message);
    }

    if (status === 367) {
      const message = {
        title: "STORE_NOT_VALID",
        text: "SSome stores is not valid or does not exists in the system.",
      }
      store.commit("setError", message);
    }

    if (status === 369) {
      const message = {
        title: "POST_CREATE_UPDATE_ERROR",
        text: "Some error occured during post creation/updation.",
      }
      store.commit("setError", message);
    }

    if (status === 371) {
      const message = {
        title: "STRING_CONTAINS_URL",
        text: "URLs doesn't allowed in this context.",
      }
      store.commit("setError", message);
    }

    if (status === 373) {
      const message = {
        title: "POST_LIKE_DISLIKE_ERROR",
        text: "Some error occured while liking/disliking the posts.",
      }
      store.commit("setError", message);
    }

    if (status === 375) {
      const message = {
        title: "PROFILE_UPDATE_ERROR",
        text: "Some error occured while updating profile.",
      }
      store.commit("setError", message);
    }

    if (status === 377) {
      const message = {
        title: "LOW_BALANCE",
        text: "There is not enough money in your wallet.",
      }
      store.commit("setError", message);
    }

    if (status === 379) {
      const message = {
        title: "PRIVATE_SESSION_ERROR",
        text: "This is private session you cannot join this session.",
      }
      store.commit("setError", message);
    }

    if (status === 378) {
      const message = {
        title: "USER_ALREADY_SUBSCRIBED",
        text: "You have already subscribed to the Fitclass with this email.",
      }
      store.commit("setError", message);
    }

    if (status === 381) {
      const message = {
        title: "PRIVATE_PAYMENT_NOT_VALID_USER",
        text: "You are not subscribed or valid user for this private entity. You can't pay for this.",
      }
      store.commit("setError", message);
    }

    if (status === 385) {
      const message = {
        title: "RESEND_EMAIL_VERIFICATION_ERROR",
        text: "Email has already been sent",
      }
      store.commit("setError", message);
    }

    if (status === 386) {
      const message = {
        title: "SESSION_COMPLETED",
        text: "This session is completed/expired.",
      }
      store.commit("setError", message);
    }

    if (status === 389) {
      const message = {
        title: "REPORTING_CREATE_UPDATE_ERROR",
        text: "There is an error occured while reporting your concern.",
      }
      store.commit("setError", message);
    }

    if (status === 393) {
      const message = {
        title: "PASSWORD_RESET_EMAIL_ALREDY_SENT",
        text: "Password reset email is already sent. check after sometime.",
      }
      store.commit("setError", message);
    }

    if (status === 395) {
      const message = {
        title: "INVALID_PASSWORD",
        text: error.response && error.response.data.message, // "Password is invalid."
      }
      store.commit("setError", message);
    }

    if (status === 397) {
      const message = {
        title: "PAYPAL_VALIDATION_ERROR",
        text: "Invalid request.",
      }
      store.commit("setError", message);
    }

    if (status === 399) {
      const message = {
        title: "PAYPAL_INSUFFICIENT_FUNDS",
        text: "Sender does not have sufficient funds. Please add funds and retry.",
      }
      store.commit("setError", message);
    }

    if (status === 391) {
      const message = {
        title: "CATEGORY_CREATE_UPDATE_ERROR",
        text: "An error occured during the creation/update of the category.",
      }
      store.commit("setError", message);
    }

    if (status === 398) {
      const message = {
        title: "ACTIVE_SESSION",
        text: "Can't delete this session is active.",
      }
      store.commit("setError", message);
    }

    if (status === 422) {
      var e = error.response.data.errors;
      for (let key in e) {
        const message = {
          title: "REQUIRED_PARAMETER",
          text: e[key][0],
        }
        store.commit("setError", message);
      }
    }

    if (status === 383) {
      if (error && error.response && error.response.data && error.response.data.data && error.response.data.data.token) {
        Cookies.set('token', error.response.data.data.token, { expires: 30 });
      }
      if (error && error.response && error.response.data && error.response.data.data && error.response.data.data.user) {
        localStorage.setItem('user', JSON.stringify(error.response.data.data.user))
      }

      //If not guest account type, re-route to step 3
      // if (localStorage.getItem('isGuest') != 1) {
      //   router.push({ name: 'Register', query: { step: 3 } })
      // }
      const message = {
        title: error.response && error.response.data.messageCode,
        text: error.response && error.response.data.message && error.response.data.message.message,
      }
      store.commit("setError", message);
    }

    if (status === 387) {
      if (error && error.response && error.response.data && error.response.data.data && error.response.data.data.token) {
        Cookies.set('token', error.response.data.data.token, { expires: 30 });
      }
      if (error && error.response && error.response.data && error.response.data.data && error.response.data.data.user) {
        localStorage.setItem('user', JSON.stringify(error.response.data.data.user))
      }
      // let user = JSON.parse(localStorage.getItem("user"));
      // if (user.user_type == 1) {
      //   router.push({ name: 'Register', query: { step: 4 } })
      // } else if (user.user_type == 2) {
      //   router.push({ name: 'Register', query: { step: 4 } })
      // } else if (user.user_type == 0) {
      //   router.push({ name: 'Register', query: { step: 4 } })
      // }
      const message = {
        title: error.response && error.response.data.messageCode,
        text: error.response && error.response.data.message && error.response.data.message.message,
      }
      store.commit("setError", message);
    }

    // if (status === 403) {
    //   const message = {
    //     title: error.response && error.response.data.messageCode,
    //     text: error.response && error.response.data.message,
    //   }
    //   store.commit("setError", message);
    // }

    if (status === 400) {
      const message = {
        title: "Bad Request",
        text: "The request was unacceptable, often due to missing a required parameter.",
      }
      store.commit("setError", message);
    }

    if (status === 401) {
      store.dispatch('logout', '401')
      const message = {
        title: "Bad Request",
        text: "Your Session has been expired, try logging in again.",
      }
      store.commit("setError", message);
    }

    if (status === 402) {
      const message = {
        title: "Request Failed",
        text: "The parameters were valid but the request failed.",
      }
      store.commit("setError", message);
    }

    if (status === 409) {
      const message = {
        title: "Conflict",
        text: "The request conflicts with another request (perhaps due to using the same idempotent key).",
      }
      store.commit("setError", message);
    }

    if (status === 409) {
      const message = {
        title: "Conflict",
        text: "The request conflicts with another request (perhaps due to using the same idempotent key).",
      }
      store.commit("setError", message);
    }

    if (status === 429) {
      const message = {
        title: "Conflict",
        text: "Too Many Requests	Too many requests hit the API too quickly. We recommend an exponential backoff of your requests.",
      }
      store.commit("setError", message);
    }

    if (status === 500 || error.response && error.response.status === 500) {
      const message = {
        title: "Server Errors",
        text: "Something went wrong",
      }
      store.commit("setError", message);
    }

    if (status === 502) {
      const message = {
        title: "Server Errors",
        text: "Something went wrong",
      }
      store.commit("setError", message);
    }

    if (status === 503) {
      const message = {
        title: "Server Errors",
        text: "Something went wrong",
      }
      store.commit("setError", message);
    }

    if (status === 504) {
      const message = {
        title: "Server Errors",
        text: "Something went wrong",
      }
      store.commit("setError", message);
    }

    return Promise.reject(error);
  }
);